import BaseAxiosRequest from '@r1-frontend/do-request/core/BaseAxiosRequest';
import { DoRequest } from '@r1-frontend/do-request/core/DoRequest';
export var doRequest = new DoRequest(new BaseAxiosRequest());
